import React from "react";
import {LibraryDomainUseDTO, LibraryDTO, LibraryGoalUseDTO} from "../../../models/library";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {Box} from "@material-ui/core";
import {InfoActionButton} from "../../common/buttons";
import {GoalDialog} from "../../values/dialogs/GoalDialog";
import {compareByAttr} from "../../../utils/compare";
import {LibraryIndicatorBrowser} from "./LibraryIndicatorBrowser";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";

interface LibraryGoalBrowserProps {
    library: LibraryDTO;
    libraryDomainUse: LibraryDomainUseDTO;
    libraryGoalUse: LibraryGoalUseDTO;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        goalRow: {
            display: "flex",
            alignItems: "center",
            padding: `${theme.spacing(1.25)}px ${theme.spacing(2)}px ${theme.spacing(1.25)}px ${theme.spacing(4)}px`,
            borderBottom: "1px solid #F3F4F6",
            cursor: "pointer",
            backgroundColor: "#ffffff",
            "&:hover": {
                backgroundColor: "#F9FAFB",
            },
        },
        chevron: {
            color: "#9CA3AF",
            padding: "4px",
            marginRight: theme.spacing(0.5),
        },
        goalName: {
            flexGrow: 1,
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "#374151",
        },
        indicatorsContainer: {},
    })
);

export const LibraryGoalBrowser: React.FC<LibraryGoalBrowserProps> = (props: LibraryGoalBrowserProps) => {
    const classes = useStyles();
    const [infoOpen, setInfoOpen] = React.useState(false);
    const [childOpen, setChildOpen] = React.useState(false);

    const hasIndicators = props.libraryGoalUse.libraryIndicatorUses.length > 0;

    return (
        <Box>
            <Box className={classes.goalRow} onClick={() => hasIndicators && setChildOpen(!childOpen)}>
                <IconButton
                    className={classes.chevron}
                    size="small"
                    style={{visibility: hasIndicators ? "visible" : "hidden"}}
                    onClick={(e) => {
                        e.stopPropagation();
                        setChildOpen(!childOpen);
                    }}
                >
                    {childOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                </IconButton>
                <Box className={classes.goalName}>{props.libraryGoalUse.goal.name}</Box>
                <Box onClick={(e) => e.stopPropagation()}>
                    <InfoActionButton onClick={() => setInfoOpen(true)} />
                </Box>
                <GoalDialog goal={props.libraryGoalUse.goal} handleClose={() => setInfoOpen(false)} open={infoOpen} />
            </Box>
            {childOpen && (
                <Box className={classes.indicatorsContainer}>
                    {props.libraryGoalUse.libraryIndicatorUses
                        .sort(compareByAttr("order", "ascending"))
                        .map((indicator) => (
                            <LibraryIndicatorBrowser key={indicator.id} libraryIndicatorUse={indicator} {...props} />
                        ))}
                </Box>
            )}
        </Box>
    );
};
